import { format } from 'date-fns';

export const formatDateSafe = (
  date?: string | Date | null,
  formatStr = 'MM/dd/yyyy'
): string => {
  if (!date) {
    return '';
  }

  return format(new Date(date), formatStr);
};
